import React, { useEffect, useState, useContext } from 'react';
import { Table, Button, message, Space, Pagination } from 'antd';
import { useNavigate } from 'react-router-dom';
import { LoginContext } from '../../../../context/loginContext';

const CListaUsuariosEmpresa = () => {
    const { user } = useContext(LoginContext);
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    
    // Estados para paginación
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0
    });

    const fetchUsuarios = async (page = 1, limit = 10) => {
        try {
            setLoading(true);
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/usuarios/usuarios-by-empresa/${user.emp_id}?page=${page}&limit=${limit}`, {
                headers: { Authorization: `Bearer ${user.token}` }
            });

            if (!res.ok) throw new Error('Error al obtener usuarios');

            const response = await res.json();
            
            // Actualizar usuarios y datos de paginación
            setUsuarios(response.data);
            setPagination({
                current: response.pagination.currentPage,
                pageSize: response.pagination.limit,
                total: response.pagination.total,
                totalPages: response.pagination.totalPages
            });
        } catch (error) {
            console.error(error);
            message.error('Error al cargar usuarios');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsuarios();
    }, []);

    // Manejador de cambio de página
    const handlePageChange = (page, pageSize) => {
        fetchUsuarios(page, pageSize);
    };

    const columns = [
        {
            title: 'Usuario',
            dataIndex: 'usu_usuario',
            key: 'usu_usuario',
        },
        {
            title: 'Sucursal',
            dataIndex: 'suc_nombre',
            key: 'suc_nombre',
        },
        {
            title: 'Acciones',
            key: 'acciones',
            render: (_, record) => (
                <Space>
                    <Button onClick={() => navigate(`/usuarios-empresa/editar/${record.usu_id}`, { state: record })}>
                        Editar
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <div style={{ padding: '2rem' }}>
            <h2>Listado de Usuarios</h2>
            <Button 
                type="primary" 
                onClick={() => navigate('/usuarios-empresa/nueva')} 
                style={{ marginBottom: '1rem' }}
            >
                Agregar Usuario
            </Button>

            <Table
                columns={columns}
                dataSource={usuarios}
                rowKey="usu_id"
                loading={loading}
                pagination={false} // Desactivamos la paginación interna de la tabla
            />
            
            {/* Componente de paginación separado para más control */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
                <Pagination
                    current={pagination.current}
                    total={pagination.total}
                    pageSize={pagination.pageSize}
                    onChange={handlePageChange}
                    showSizeChanger={false} // Opcionalmente, deshabilitamos el cambio de tamaño de página
                    showTotal={(total, range) => `${range[0]}-${range[1]} de ${total} usuarios`}
                />
            </div>
        </div>
    );
};

export default CListaUsuariosEmpresa;